import { MoveSiteToHouseholderErrorCode } from "@/domains/site/site.errors";

const moveSiteCodes: Record<MoveSiteToHouseholderErrorCode, string> = {
  [MoveSiteToHouseholderErrorCode.INVALID_SEGMENT]:
    "Le segment d'activité de ce site ne permet pas de le convertir en site particulier.",
  [MoveSiteToHouseholderErrorCode.SITE_HAS_PLANNED_APPOINTMENT]:
    "Ce site a un rendez-vous planifié et ne peut pas être converti en site particulier.",
  [MoveSiteToHouseholderErrorCode.SITE_HAS_NO_SUBSCRIBER]:
    "Un adhérent doit être rattaché au site avant de pouvoir être converti en site particulier.",
  [MoveSiteToHouseholderErrorCode.SITE_HAS_NO_LAYOUT]:
    "Le type de site doit être renseigné avant de pouvoir le convertir en site particulier.",
  [MoveSiteToHouseholderErrorCode.PROFESSIONAL_LAYOUT_WITHOUT_SMALL_COMPANY]:
    "Un local professionnel ne peut être converti en site particulier que si son adhérent est un petit pro.",
};

const codes = { ...moveSiteCodes };

const errorsLocale = {
  errors: {
    codes,
    unknownCode: "Une erreur est survenue. Merci de réessayer ultérieurement. Code d'erreur : {code}",
    invalidType: "Le champ est invalide",
    invalidTypeReceivedUndefined: "Obligatoire",
    invalidLiteral: "Le champ est invalide",
    unrecognizedKeys: "Clés non reconnues",
    invalidUnion: "Le champ est invalide",
    invalidUnionDiscriminator: "Valeur de discriminant invalide. Attendue {options}",
    invalidEnumValue: "Option invalide. Attendue : {options}",
    invalidArguments: "Paramètres de fonction invalides",
    invalidReturnType: "Valeur de fonction retournée invalide",
    invalidDate: "Date invalide",
    custom: "Le champ est invalide",
    invalidIntersectionTypes: "Les résultats d'intersection ne peuvent pas être fusionnés",
    notMultipleOf: "Le nombre doit être un multiple de {multipleOf}",
    notFinite: "Le nombre doit être fini",
    invalidString: {
      email: "E-mail invalide",
      url: "URL invalide",
      uuid: "UUID invalide",
      cuid: "CUID invalide",
      regex: "Le champ est invalide",
      datetime: "Date et heure invalide",
      startsWith: "Le champ est invalide : doit commencer par {startsWith}",
      endsWith: "Le champ est invalide : doit se terminer par {endsWith}",
    },
    tooSmall: {
      array: {
        exact: "Insérer {minimum} élément | Insérer {minimum} éléments",
        inclusive: "Insérer au moins {minimum} élément | Insérer au moins {minimum} éléments",
        notInclusive: "Insérer plus de {minimum} élément | Insérer plus de {minimum} éléments",
      },
      string: {
        exact: "La longueur doit être de {minimum} caractère | La longueur doit être de {minimum} caractères",
        inclusive: "Longueur minimale de {minimum} caractère | Longueur minimale de {minimum} caractères",
        notInclusive: "Insérer plus de {minimum} caractère | Insérer plus de {minimum} caractères",
      },
      number: {
        exact: "La valeur doit être {minimum}",
        inclusive: "Insérer une valeur supérieure ou égale à {minimum}",
        notInclusive: "Insérer une valeur supérieure à {minimum}",
      },
      set: {
        exact: "Le champ est invalide",
        inclusive: "Le champ est invalide",
        notInclusive: "Le champ est invalide",
      },
      date: {
        exact: "La date doit être {minimum}",
        inclusive: "La date doit être postérieure ou égale à {minimum}",
        notInclusive: "La date doit être postérieure à {minimum}",
      },
    },
    tooBig: {
      array: {
        exact: "Insérer {maximum} élément | Insérer {maximum} éléments",
        inclusive: "Insérer au plus {maximum} élément | Insérer au plus {maximum} éléments",
        notInclusive: "Insérer moins de {maximum} élément | Insérer moins de {maximum} éléments",
      },
      string: {
        exact: "La longueur doit être de {maximum} caractère | La longueur doit être de {maximum} caractères",
        inclusive: "Longueur maximale de {maximum} caractère | Longueur maximale de {maximum} caractères",
        notInclusive: "Insérer moins de {maximum} caractère | Insérer moins de {maximum} caractères",
      },
      number: {
        exact: "La valeur doit être {maximum}",
        inclusive: "Insérer une valeur inférieure ou égale à {maximum}",
        notInclusive: "Insérer une valeur inférieure à {maximum}",
      },
      set: {
        exact: "Le champ est invalide",
        inclusive: "Le champ est invalide",
        notInclusive: "Le champ est invalide",
      },
      date: {
        exact: "La date doit être {maximum}",
        inclusive: "La date doit être antérieure ou égale à {maximum}",
        notInclusive: "La date doit être antérieure à {maximum}",
      },
    },
  },
};

export type ErrorsLocale = typeof errorsLocale;
export default errorsLocale;
